<template>
  <div id="app">
    <span>
      <img id="title" src="@/assets/crossable-logo.png" height="35px" />
      <span class="nav">
        <router-link to="/">Map</router-link> |
        <router-link to="/list">List</router-link> |
        <router-link to="/about">About</router-link>
      </span>
    </span>
    <router-view/>
    <span v-if="!activeUser"
      class="footerItem isButton"
      v-on:click="login()">
      <LoginVector
        width="16px"
        height="16px"
        title="Login with a Google or Facebook Account"
        class="footerIcon"/>Sign In
    </span>
    <div v-else>
      <span class="footerItem isButton"
        v-on:click="logout()">
        <LogoutVector
          width="18px"
          height="16px"
          title="Sign out of Crossable"
          class="footerIcon"/>Sign Out
      </span>
      <span id="userid">{{ activeUser.email }}</span>
    </div>
  </div>
</template>

<script>

import LoginVector from '@/components/icons/LoginVector.vue';
import LogoutVector from '@/components/icons/LogoutVector.vue';

export default {

  name: 'app',

  components: {
    LoginVector,
    LogoutVector,
  },

  data() {
    return {
      activeUser: null,
      isAuthenticated: false,
      publicPath: process.env.BASE_URL,
    };
  },

  created() {
    this.updateAuth();
  },

  watch: {
    // everytime a route is changed refresh the activeUser
    $route: 'updateAuth',
  },

  methods: {
    login() {
      this.$auth.loginRedirect();
    },

    async updateAuth() {
      this.activeUser = await this.$auth.getUser();
      this.isAuthenticated = await this.$auth.isAuthenticated();
      console.log(this.activeUser);
    },

    async logout() {
      await this.$auth.logout();
      await this.refreshActiveUser();
      this.$router.push('/');
    },
  },
};
</script>

<style>

@media only screen and (max-width: 450px) {
  .nav {
    padding: 0px 14px 0px 14px !important;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#userid {
  font-style: italic;
}

.footerItem {
    padding-top: 16px;
    padding-bottom: 8px;
    padding-left: 16px;
    display: block;
}

.footerIcon {
  display: inline-block;
  vertical-align: middle;
  padding-bottom: 4px;
  padding-right: 6px;
}

.isButton {
    cursor: pointer;
}

#title {
  vertical-align: -50%;
}

#map {
  height: 5%;
}

.nav {
  padding: 14px;
}

.nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

.nav a.router-link-exact-active {
  color: #C0392B;
}

#footerContainer {
  padding-top: 10px;
}

body {
  font-family: Avenir, Arial, Helvetica, sans-serif;
  font-size: 16px;
}

</style>
